import React from "react";
import styles from "../../../assets/stylesheets/blog/FarmmodeBlogDetail.module.css";
import MainImg from "../../../assets/img/blog/lavender/MainLavender.webp"; 

import Bonnieheath from "../../../assets/img/blog/lavender/Bonnieheath.webp"; 
import HerewardFarm from "../../../assets/img/blog/lavender/HerewardFarm.webp"; 
import Laveanne from "../../../assets/img/blog/lavender/Laveanne.webp"; 
import Lavender from "../../../assets/img/blog/lavender/Lavender.webp"; 
import LavenderWorks from "../../../assets/img/blog/lavender/LavenderWorks.webp"; 
import PrinceEdward from "../../../assets/img/blog/lavender/PrinceEdward.webp"; 
import PurpleHill from "../../../assets/img/blog/lavender/PurpleHill.webp"; 
import Ridgeway from "../../../assets/img/blog/lavender/Ridgeway.webp"; 
import Woodland from "../../../assets/img/blog/lavender/Woodland.webp"; 



const LAVENDER_FARMS = [
  {
    id: "york",
    region: "York, Durham & Headwaters",
    farms: [
      {
        name: "Hereward Farms",
        img: HerewardFarm,
        description: "Visit over 6,000 lavender plants and shop for luxurious, non-toxic, cruelty-free body and home products. Lavender Lounge + Boutique is also on site.",
        location: "141051 15 Sideroad, East Garafraxa, ON",
        website: "Hereward Farms",
        webUrl: "https://www.herewardfarm.com/"
      },
      {
        name: "Christel Lake Lavender",
        description: "Lavender fields surround a spring-fed lake; includes a playground and gift shop with lavender-infused products.",
        location: "1381 Scugog Line 12, Greenbank, ON",
        website: "Christel Lake Lavender",
        webUrl: "https://christellakelavender.com/"
      },
      {
        name: "Erin Hill Acres",
        description: "Christmas tree farm also featuring lavender, sunflowers, wagon rides, nature trails, and Highland cows.",
        location: "5837 3 Line, Hillsburgh, ON",
        website: "Erin Hill Acres",
        webUrl: "https://erinhillacres.farm/"
      },
      {
        name: "Avalon Lavender Farm",
        description: "Home to over 30,000 lavender plants with cut-your-own bundles, yoga classes, and boutique lavender products.",
        location: "347036 Mono Centre Road, Mono, ON",
        website: "Avalon Lavender Farm",
        webUrl: "https://avalonlavenderfarm.ca/"
      },
      {
        name: "The Giving Place",
        description: "Pesticide-free farm with beehives, chickens, rescue bunnies, and a shop featuring lavender products. Hosts high tea, yoga, and sound bath sessions.",
        location: "19618 East Townline, Mount Albert ON",
        website: "The Giving Place",
        webUrl: "https://thegivingplace.ca/"
      },
      {
        name: "Lavender Polo Farm",
        description: "Expansive farm with over 100,000 English and Spanish lavender plants. Lavender refreshments and products available.",
        location: "20132 McCowan Road, East Gwillimbury, ON",
        website: "Lavender Polo Farm",
        webUrl: "https://lavenderpolo.com/"
      },
      {
        name: "Lilit Botanicals",
        description: "Urban botanical apothecary with handmade lavender and botanical skincare. Check their boutique for small-batch items.",
        location: "29-260 Edgeley Blvd, Concord, ON",
        website: "Lilit Botanicals",
        webUrl: "https://lilitbotanicals.com/"
      },
      {
        name: "Wild Blue Acres Farmstead",
        description: "Small farmstead in Whitby offering fresh lavender and artisan products.",
        location: "4840 Coronation Rd, Whitby, ON",
        website: "Wild Blue Acres",
        webUrl: "https://www.wildblueacres.ca/"
      },
      {
        name: "Creation Farms",
        description: "Family-run farm selling lavender products at markets and pop-ups.",
        location: "200 Doug Duncan Dr, Newmarket, ON",
        website: "Creation Farms",
        webUrl: "https://creationfarms.com/"
      },
      {
        name: "Tranquility Trails Farm",
        description: "Lavender experience farm with meditation, walking trails, and essential oils.",
        location: "5240 Lakeridge Rd N, Pickering, ON",
        website: "Tranquility Trails Farm",
        webUrl: "https://tranquilitytrails.com/"
      },
      {
        name: "Gray Silo Lavender Farm",
        description: "A picturesque lavender farm near Port Perry offering fresh lavender bundles and handmade products.",
        location: "455 Reach St, Port Perry, ON",
        website: "Gray Silo Lavender Farm",
        webUrl: "https://graysilolavender.ca/"
      },
      {
        name: "Vive Lavender Farm",
        description: "Offers U-pick, wellness workshops, and high-quality products.",
        location: "85 Concession Rd 4, Sunderland, ON",
        website: "Vive Lavender Farm",
        webUrl: "https://vivelavender.com/"
      },
      {
        name: "Lavender Fox Farm",
        description: "Eco-conscious farm focusing on sustainable lavender production.",
        location: "2479 Concession Rd 3, Palgrave, ON",
        website: "Lavender Fox Farm",
        webUrl: "https://lavenderfox.com/"
      }
    ]
  },
  {
    id: "sw",
    region: "Southwestern Ontario",
    farms: [
      {
        name: "Bonnieheath Estate Lavender and Winery",
        img: Bonnieheath,
        description: "Lavender farm and winery within Long Point UNESCO Biosphere. Enjoy lavender dessert wines and explore the scenic grounds.",
        location: "410 Concession 12 Townsend, Waterford, ON",
        website: "Bonnieheath Estate Lavender and Winery",
        webUrl: "https://www.bonnieheathestate.com/"
      },
      {
        name: "R&B Lavender",
        description: "Family-owned farm with lavender yoga, picnics, and unique lavender goods.",
        location: "23615 Amiens Road, Mount Brydges, ON",
        website: "R&B Lavender",
        webUrl: "https://www.rblavender.com/"
      },
      {
        name: "Apple Hill Lavender",
        description: "Part of a century farm with lavender fields, boutique products, and picnic areas.",
        location: "1795 Windham Road 11, Windham Centre, ON",
        website: "Apple Hill Lavender",
        webUrl: "https://applehilllavender.com/"
      },
      {
        name: "Serenity Lavender Farm",
        description: "Canada’s most southern lavender farm. Offers farm tours and wine tastings at North 42 Degrees Estate Winery.",
        location: "130 County Road 50, Essex, ON",
        website: "Serenity Lavender Farm",
        webUrl: "https://serenitylavender.com/"
      },
      {
        name: "Purple Haven Lavender Farm",
        description: "Offers picnics in lavender fields, forest walks, and a seasonal sunflower and pumpkin patch.",
        location: "6834 Highway 3, Canfield, ON",
        website: "Purple Haven Lavender Farm",
        webUrl: "https://purplehaven.ca/"
      },
      {
        name: "Sparta Lavender",
        description: "Offers essential oils, culinary lavender, and beautiful summer photo ops.",
        location: "47589 Sparta Line, Aylmer, ON",
        website: "Sparta Lavender",
        webUrl: "https://spartalavender.ca/"
      },
      {
        name: "Lavender Hives",
        description: "Lavender and honey farm near Grand Bend offering eco-friendly products.",
        location: "8499 Goosemarsh Line, Grand Bend, ON",
        website: "Lavender Hives",
        webUrl: "https://lavenderhives.ca/"
      }
    ]
  },
  {
    id: "hamilton",
    region: "Hamilton, Halton & Brant",
    farms: [
      {
        name: "The Lavender Farm",
        img: Lavender,
        description: "Historic farm and popular wedding venue with vast fields and rustic elements.",
        location: "769 Drumbo Road, Ayr, ON",
        website: "The Lavender Farm",
        webUrl: "https://thelavenderfarm.ca/"
      },
      {
        name: "Kelso Lavender",
        description: "Farm with over 25,000 pesticide-free plants and a shop with lavender-infused personal care products.",
        location: "8649 Appleby Line, Campbellville, ON",
        website: "Kelso Lavender",
        webUrl: "https://kelsolavender.com/"
      },
      {
        name: "Blóm Lavender Farm",
        description: "Boutique family farm growing lavender with Nordic design influences.",
        location: "1166 Safari Rd, Millgrove, ON",
        website: "Blóm Lavender Farm",
        webUrl: "https://blomlavender.ca/"
      },
      {
        name: "Between the Vines Lavender Estate",
        description: "Hamilton-area lavender estate with photography bookings and lavender-centric events.",
        location: "223 Weirs Lane, Hamilton, ON",
        website: "Between the Vines Lavender Estate",
        webUrl: "https://betweenthevines.ca/"
      },
      {
        name: "MiKel’s Lavender Oasis",
        description: "A lavender retreat in Binbrook with handmade soaps, lotions, and workshops.",
        location: "5127 Harrison Road, Binbrook, ON",
        website: "MiKel’s Lavender Oasis",
        webUrl: "https://mikelslavenderoasis.com/"
      }
    ]
  },
  {
    id: "se",
    region: "Southeastern Ontario",
    farms: [
      {
        name: "Prince Edward County Lavender",
        img: PrinceEdward,
        description: "Hosts a two-day Lavender Festival and offers a range of lavender-infused goods.",
        location: "732 Closson Road, Hillier, ON",
        website: "Prince Edward County Lavender",
        webUrl: "https://peclavender.com/"
      },
      {
        name: "Solid Rock Lavender Fields & Farm",
        description: "Roslin-area grower producing lavender oils and handmade farm goods.",
        location: "13 Cross Rd, Roslin, ON",
        website: "Solid Rock Lavender",
        webUrl: ""
      },
      {
        name: "Violet Hill Lavender",
        description: "Roslin-area grower producing lavender oils and handmade farm goods.",
        location: "3634 County Road 8, Picton, ON",
        website: "Violet Hill Lavender",
        webUrl: "https://violethilllavender.com/"
      },
      {
        name: "Lavender Queen Lavender Farm",
        description: "Boutique lavender grower in Yarker with handcrafted botanical items.",
        location: "3981 County Road 1 East, Yarker, ON",
        website: "Lavender Queen Lavender Farm",
        webUrl: "https://lavenderqueen.ca/"
      },
      {
        name: "Laberge Lavender Lane",
        description: "Addison-based homestead with community farming and lavender growing.",
        location: "10445 County Rd 7, Addison, ON",
        website: "Laberge Lavender Lane",
        webUrl: ""
      },
      {
        name: "Manitoulin Farmstead",
        description: "Lavender farm on Manitoulin Island offering retreats and workshops.",
        location: "777 Rockville Rd, Mindemoya, ON",
        website: "Manitoulin Farmstead",
        webUrl: "https://manitoulinfarmstead.ca/"
      },
      {
        name: "Lavande Braydale Lavender",
        description: "Family-run farm in Moose Creek specializing in culinary and craft lavender.",
        location: "17683 Sandringham Rd, Moose Creek, ON",
        website: "Lavande Braydale Lavender",
        webUrl: "https://lavandebraydale.ca/"
      },
      {
        name: "LouLou Lavender",
        description: "Charming lavender business in Williamstown offering lavender-based gifts.",
        location: "19918 Maple Rd, Williamstown, ON",
        website: "LouLou Lavender",
        webUrl: "https://louloulavender.ca/"
      }
    ]
  },
  {
    id: "bruce",
    region: "Bruce, Grey & Simcoe",
    farms: [
      {
        name: "Purple Hill Lavender Farm",
        img: PurpleHill,
        description: "Family-run farm offering yoga, picnics, live music, and curated lavender products.",
        location: "7484 6/7 Sideroad Nottawasaga, Creemore, ON",
        website: "Purple Hill Lavender Farm",
        webUrl: "https://purplehilllavender.com/"
      },
      {
        name: "South Bay Fields",
        description: "Offers fresh lavender bundles, bath products, and essential oil distillation onsite.",
        location: "7527 Nottawasaga 36/37 Sideroad, Collingwood, ON",
        website: "South Bay Fields",
        webUrl: "https://southbayfields.ca/"
      },
      {
        name: "The Purple Hollow",
        description: "Boutique lavender farm with a shop for handcrafted and local artisan goods.",
        location: "637295 St. Vincent-Sydenham Townline, Meaford, ON",
        website: "The Purple Hollow",
        webUrl: "https://thepurplehollow.ca/"
      },
      {
        name: "Essentially Lavender",
        description: "Features a labyrinth, apiary, and gardens. Onsite boutique and overnight stays available.",
        location: "1379 Concession 10, Formosa, ON",
        website: "Essentially Lavender",
        webUrl: "https://essentiallylavender.ca/"
      },
      {
        name: "Bluewater Lavender",
        description: "Hosts the Wiarton Lavender Festival and offers farm tours and handmade goods.",
        location: "441016 Elm Street, Georgian Bluffs, ON",
        website: "Bluewater Lavender",
        webUrl: "https://bluewaterlavender.ca/"
      },
      {
        name: "Stonewell Farm",
        description: "Boutique lavender farm in Erin with fresh bundles and essential oils.",
        location: "9762 Wellington Rd 42, Erin, ON",
        website: "Stonewell Farm",
        webUrl: "https://stonewellfarm.ca/"
      },
      {
        name: "Lavender Valley Farm",
        description: "Offers fresh lavender bundles, oils, and natural body products.",
        location: "5505 6 Line, Cookstown, ON",
        website: "Lavender Valley Farm",
        webUrl: "https://lavendervalleyfarm.ca/"
      },
      {
        name: "Lavender North",
        description: "A peaceful lavender retreat in Oro Medonte with small-batch lavender products.",
        location: "425 Line 8 North, Oro Medonte, ON",
        website: "Lavender North",
        webUrl: "https://lavendernorth.ca/"
      },
      {
        name: "Mad & Noisy Lavender",
        description: "Scenic farm in Creemore offering a rustic experience surrounded by nature.",
        location: "2295 Riverside Dr, Creemore, ON",
        website: "Mad & Noisy Lavender",
        webUrl: "https://madandnoisylavender.ca/"
      },
      {
        name: "Lavender Creek Farm",
        description: "Badjeros-based farm offering essential oils, dried bundles, and workshops.",
        location: "309105 Centre Line B, Badjeros, ON",
        website: "Lavender Creek Farm",
        webUrl: "https://lavendercreek.ca/"
      },
      {
        name: "Heron’s Hollow Farm",
        description: "Boutique farm in Feversham blending wild flora, lavender, and heritage farming.",
        location: "428102 8th Concession A, Feversham, ON",
        website: "Heron’s Hollow Farm",
        webUrl: "https://heronshollow.ca/"
      },
      {
        name: "Garden Gate Farmstead",
        description: "Southampton farm offering lavender-based lifestyle and floral products.",
        location: "319 Carlisle St, Southampton, ON",
        website: "Garden Gate Farmstead",
        webUrl: "https://gardengatefarmstead.ca/"
      },
      {
        name: "East Road Farm Lavender & Apiary",
        description: "Lavender and honey farm on the Bruce Peninsula with farm tours and more.",
        location: "1245 East Road, Dyer's Bay, ON",
        website: "East Road Farm",
        webUrl: "https://eastroadfarm.ca/"
      },
      {
        name: "Luscious Lavender & Herb Farm",
        description: "Hanover farm producing lavender oils and body care using organic methods.",
        location: "133668 Allan Park Rd, Hanover, ON",
        website: "Luscious Lavender Farm",
        webUrl: "https://lusciouslavender.ca/"
      },
      {
        name: "Bayfield Lavender Farm",
        description: "Farm near Lake Huron featuring small-batch oils and botanical collections.",
        location: "77881 Porters Hill Line, Bayfield, ON",
        website: "Bayfield Lavender Farm",
        webUrl: "https://bayfieldlavender.ca/"
      }
    ]
  },
  {
    id: "niagara",
    region: "Niagara Region",
    farms: [
      {
        name: "Ridgeway Lavender",
        img: Ridgeway,
        description: "Tour the fields and purchase plants, essential oils, and lavender products.",
        location: "3359 Third Concession, Port Colborne, ON",
        website: "Ridgeway Lavender",
        webUrl: "https://ridgewaylavender.ca/"
      },
      {
        name: "Freeman Herbs Inc.",
        description: "Large herb grower including lavender. Offers lavender plants for wholesale and garden centres.",
        location: "4075 N Service Rd, Lincoln, ON",
        website: "Freeman Herbs",
        webUrl: "https://freemanherbs.ca/"
      },
      {
        name: "Frisia Flora Greenhouses",
        description: "Beamsville-based grower offering lavender plants and cuttings.",
        location: "3865 King Street, Beamsville, ON",
        website: "Frisia Flora Greenhouses",
        webUrl: "https://frisiaflora.ca/"
      }
    ]
  },
  {
    id: "kawarthas",
    region: "Kawarthas & Northumberland",
    farms: [
      {
        name: "Laveanne Lavender Fields",
        img: Laveanne,
        description: "Features over 80 lavender varieties in scenic rolling hills.",
        location: "8667 Gilmour Road, Campbellcroft, ON",
        website: "Laveanne Lavender Fields",
        webUrl: "https://laveanne.ca/"
      },
      {
        name: "McDermott Country Meadow",
        description: "Farm in Little Britain offering lavender experiences and seasonal markets.",
        location: "178 Port Hoover Rd, Little Britain, ON",
        website: "McDermott Country Meadow",
        webUrl: "https://mcdermottcountrymeadow.ca/"
      },
      {
        name: "Nan’s Lavender Shop",
        description: "Small shop in Lindsay with handmade lavender products and decor items.",
        location: "339 Cheese Factory Rd, Lindsay, ON",
        website: "Nan’s Lavender Shop",
        webUrl: "https://nanslavendershop.ca/"
      },
      {
        name: "Get Calm Lavender and Tree Farm",
        description: "A meditative space with lavender fields, forest trails, and handmade oils.",
        location: "321 Cedar Bank Road, Otonabee, ON",
        website: "Get Calm Lavender and Tree Farm",
        webUrl: "https://getcalm.ca/"
      },
      {
        name: "Amethyst Hills Lavender Farm",
        description: "A Warkworth-area farm focused on aromatherapy products and small-scale lavender growing.",
        location: "143 Concession Rd 8 W, Warkworth, ON",
        website: "Amethyst Hills Lavender Farm",
        webUrl: "https://amethysthills.ca/"
      }
    ]
  },
  {
    id: "haliburton",
    region: "Haliburton Highlands to Ottawa Valley",
    farms: [
      {
        name: "Woodland North Lavender Farm",
        img: Woodland,
        description: "Offers U-pick, workshops, and the Lavender Festival.",
        location: "14716 North Highway 62 and 7, Madoc, ON",
        website: "Woodland North Lavender Farm",
        webUrl: "https://woodlandnorth.ca/"
      },
      {
        name: "The Kirk Farm",
        description: "A heritage homestead in Oxford Mills with lavender and heritage crops.",
        location: "2243 Beach Rd, Oxford Mills, ON",
        website: "The Kirk Farm",
        webUrl: "https://thekirkfarm.ca/"
      },
      {
        name: "Lavenbel Farm",
        description: "Lavender grower in Orleans with bilingual tours and artisanal products.",
        location: "809 Henslow's Circle, Orleans, ON",
        website: "Lavenbel Farm",
        webUrl: "https://lavenbel.ca/"
      },
      {
        name: "Les Jardins Écologiste Grégoire",
        description: "French-speaking eco lavender garden offering organic botanicals.",
        location: "2107 Route 700 Ouest, St-Albert, ON",
        website: "Les Jardins Écologiste Grégoire",
        webUrl: "https://lesjardinsecologiste.ca/"
      }
    ]
  },
  {
    id: "huron",
    region: "Huron, Perth, Waterloo & Wellington",
    farms: [
      {
        name: "Lavender Works Co.",
        img: LavenderWorks,
        description: "Offers sunset picnics and a French-style shop with handmade lavender goods.",
        location: "44702 Newry Road, Brussels, ON",
        website: "Lavender Works Co.",
        webUrl: "https://lavenderworks.ca/"
      },
      {
        name: "Tullamore Lavender Co.",
        description: "Small farm with a Lavender Bloom Festival and lavender-infused refreshments.",
        location: "7595 Wellington Road 109, Arthur, ON",
        website: "Tullamore Lavender Co.",
        webUrl: "https://tullamorelavender.ca/"
      },
      {
        name: "Erin Creek Farm",
        description: "A small-scale lavender and flower farm with rustic charm and family-friendly visits.",
        location: "9654 Side Rd 5, Erin, ON",
        website: "Erin Creek Farm",
        webUrl: "https://erincreekfarm.ca/"
      },
      {
        name: "Belfountain Estates Farm",
        description: "Artisan farm with a selection of lavender products and wellness experiences.",
        location: "17529 Shaws Creek Rd, Belfountain, ON",
        website: "Belfountain Estates Farm",
        webUrl: "https://belfountainestates.ca/"
      },
      {
        name: "Torry Lane Farms “Mille de Fleurs”",
        description: "French-inspired farm in Puslinch known for curated floral experiences.",
        location: "1281 10th Concession W, Puslinch, ON",
        website: "Torry Lane Farms",
        webUrl: ""
      },
      {
        name: "Terre Bleu (Elora Location)",
        description: "A new expansion of the famous lavender brand in a historic building.",
        location: "143 Metcalfe St., Elora, ON",
        website: "Terre Bleu",
        webUrl: "https://terrebleu.ca/"
      },
      {
        name: "Belvedere Lavender Farm",
        description: "A wellness-focused lavender farm in Woodstock.",
        location: "507 Dundas St, Woodstock, ON",
        website: "Belvedere Lavender Farm",
        webUrl: "https://belvederelavender.ca/"
      },
      {
        name: "Deep Purple Lavender Farm",
        description: "Family-owned farm in Embro with a wide selection of lavender goods.",
        location: "355548 35th Line, Embro, ON",
        website: "Deep Purple Lavender Farm",
        webUrl: "https://deeppurplelavender.ca/"
      },
      {
        name: "Little Brown Farm",
        description: "Arva-based artisan lavender grower specializing in natural beauty and self-care. Small farm with a Lavender Bloom Festival and lavender-infused refreshments.",
        location: "22007 Wonderland Rd N, Arva, ON",
        website: "Little Brown Farm",
        webUrl: "https://littlebrownfarm.ca/"
      }
    ]
  }
];

export default function LavenderFarmOntario() {
  return (
    <div className={styles.page}>

      {/* Top meta like blogTO */}
      <div className={styles["top-meta"]}>
        {/* <span className={styles["category-name"]}>Best of Winter</span>
        <span className={styles["sep"]}>•</span>
        <span>FarmCiti Team</span>
        <span className={styles["sep"]}>•</span>
        <span>Posted today</span> */}
      </div>

      {/* Main Title */}
      <h1 className={styles["title"]}>Best 5 Lavender Farms in Ontario 2025</h1>

      {/* Hero Image */}
      <div className={styles["hero-wrap"]}>
        <img
          className={styles["hero"]}
          src={MainImg}
          alt="Lavender Fields in Ontario"
        />
      </div>

      <div className={styles["lead-section"]}>
        <p><strong>A Lavender-Tinted Spring Has Arrived in Ontario!</strong><br />
        As winter fades and <strong>soft spring sunshine</strong> begins to warm the earth, <strong>lavender farms across Ontario</strong> awaken with <strong>color, scent, and serenity</strong>. <strong>Rolling fields of gentle purple</strong>, the <strong>calming aroma</strong> carried by the breeze, and the <strong>quiet joy of walking among blooms</strong>—there’s no better way to welcome the season than with a <strong>peaceful escape into nature</strong>.</p>
        
        <p><strong>Lavender farms offer more than just beautiful views</strong>. They’re <strong>immersive experiences</strong> where you can enjoy <strong>scenic strolls</strong>, shop for <strong>natural lavender-based products</strong>, join <strong>hands-on workshops</strong>, and capture <strong>picture-perfect moments</strong> surrounded by blooms. Whether you’re looking for a <strong>relaxing day trip</strong>, a <strong>romantic getaway</strong>, or a <strong>unique family outing</strong>, there’s something <strong>magical</strong> waiting in every lavender field.</p>

        <p><strong>Now’s the perfect time to plan your spring escape.</strong><br />
        We’ve rounded up some of the <strong>most charming and picturesque lavender farms across Ontario</strong> for <strong>2025</strong>. Let the <strong>scent of lavender</strong> guide you to your next <strong>unforgettable adventure</strong>.</p>
      </div>

      <div className={styles["jump-links"]}>
        {LAVENDER_FARMS.map((region, idx) => (
          <React.Fragment key={region.id}>
            <a href={`#${region.id}`}>{region.region}</a>
            {idx < LAVENDER_FARMS.length - 1 && <span> | </span>}
          </React.Fragment>
        ))}
      </div>

      <div className={styles["season-info"]}>
        🗓 <strong>Lavender Season:</strong> Mid June to Late July 2025
      </div>

      <p>Grab your sunhat, charge your camera, and get ready to wander through <strong>Ontario’s dreamiest lavender fields!</strong></p>

      {LAVENDER_FARMS.map((region) => (
        <div key={region.id} id={region.id}>
          <h2 className={styles["region-title"]}>{region.region}</h2>
          <hr className={styles["region-divider"]} />
          
          {region.farms.map((farm, fIdx) => (
            <div key={fIdx} className={styles["farm-section"]}>
              <h3 className={styles["farm-name"]}>{farm.name}</h3>
              <hr className={styles["region-divider"]} />
              
              {farm.img && <img src={farm.img} alt={farm.name} className={styles["farm-image"]} />}
              
              <div className={styles["farm-description"]}>
                {farm.description}
              </div>

              <div className={styles["event-details-title"]}>Event Details:</div>
              <ul className={styles["details-list"]}>
                <li className={styles["details-item"]}>
                  <span className={styles["details-label"]}>Location:</span> {farm.location}
                </li>
                <li className={styles["details-item"]}>
                  <span className={styles["details-label"]}>Website:</span><br />
                  <a href={farm.webUrl} className={styles["website-link"]} target="_blank" rel="noopener noreferrer">
                    {farm.website}
                  </a>
                </li>
              </ul>
              <hr className={styles["farm-divider"]} />
            </div>
          ))}
        </div>
      ))}
    </div>
  );
}
